var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "bl_area capture_area" }, [
    _c(
      "form",
      {
        attrs: { id: "frm_cargo" },
        on: {
          submit: function ($event) {
            $event.preventDefault()
          },
        },
      },
      [
        _c("h2", { staticClass: "content_title" }, [
          _vm._v(_vm._s(_vm.$t("msg.CSBL200.245"))),
        ]),
        _vm._v(" "),
        _c("table", { staticClass: "tbl_row mt10" }, [
          _vm._m(0),
          _c("tbody", [
            _c("tr", [
              _c("th", [_vm._v("Cargo Weight")]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("e-input-number", {
                    staticClass: "col_6",
                    attrs: {
                      "is-comma": true,
                      point: 3,
                      id: "grsWt",
                      maxlength: "14",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.checkValidationInfo("grsWt")
                      },
                    },
                    model: {
                      value: _vm.regParams.grsWt,
                      callback: function ($$v) {
                        _vm.$set(_vm.regParams, "grsWt", $$v)
                      },
                      expression: "regParams.grsWt",
                    },
                  }),
                  _vm._v(" Kgs "),
                ],
                1
              ),
              _c("th", [_vm._v(_vm._s(_vm.$t("art.CMATK098")))]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("e-input-number", {
                    staticClass: "dv col_6",
                    attrs: {
                      id: "grsCbm",
                      "is-comma": true,
                      point: 4,
                      maxlength: "13",
                    },
                    on: {
                      input: function ($event) {
                        return _vm.checkErrorVisible("grsCbm")
                      },
                    },
                    model: {
                      value: _vm.regParams.grsCbm,
                      callback: function ($$v) {
                        _vm.$set(_vm.regParams, "grsCbm", $$v)
                      },
                      expression: "regParams.grsCbm",
                    },
                  }),
                  _vm._v(" CBM "),
                ],
                1
              ),
              _c("th", [_vm._v(_vm._s(_vm.$t("art.CMATK100")))]),
              _vm._v(" "),
              _c(
                "td",
                [
                  _c("e-input-number", {
                    staticClass: "col_3",
                    attrs: { "is-comma": true, id: "pkgQty", maxlength: "10" },
                    on: {
                      blur: function ($event) {
                        return _vm.fnPackage("CHANGE")
                      },
                      input: function ($event) {
                        return _vm.checkValidationInfo("pkgQty")
                      },
                    },
                    model: {
                      value: _vm.regParams.pkgQty,
                      callback: function ($$v) {
                        _vm.$set(_vm.regParams, "pkgQty", $$v)
                      },
                      expression: "regParams.pkgQty",
                    },
                  }),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.regParams.pkgCd,
                          expression: "regParams.pkgCd",
                        },
                      ],
                      staticClass: "inp_space70",
                      attrs: { id: "pkgCd" },
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.regParams,
                              "pkgCd",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          function ($event) {
                            _vm.checkValidationInfo("pkgCd")
                            _vm.fnPackage("CHANGE")
                          },
                        ],
                      },
                    },
                    [
                      _c("option", { attrs: { value: "" } }, [
                        _vm._v(_vm._s(_vm.$t("msg.CSBL220.003"))),
                      ]),
                      _vm._l(_vm.pkgCdList, function (vo, idx) {
                        return _c(
                          "option",
                          { key: "pkgCd_" + idx, domProps: { value: vo.cd } },
                          [_vm._v(_vm._s(vo.cdNm))]
                        )
                      }),
                    ],
                    2
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
        _c("h2", { staticClass: "content_title" }, [
          _vm._v("Container Information"),
        ]),
        _c(
          "table",
          { staticClass: "tbl_col mt10" },
          [
            _vm._m(1),
            _c("thead", [
              _c("tr", [
                _c("th", [_vm._v("No.")]),
                _c("th", [_vm._v(_vm._s(_vm.$t("msg.CSBL200.197")))]),
                _vm._v(" "),
                _c("th", [_vm._v(_vm._s(_vm.$t("msg.CSBL200.251")))]),
                _vm._v(" "),
                _c("th", [_vm._v("HS Code")]),
                _c("th", [_vm._v(_vm._s(_vm.$t("msg.ONEX050P060.005")))]),
                _vm._v(" "),
                _c("th", [_vm._v("Measure")]),
                _c("th", [_vm._v(_vm._s(_vm.$t("art.CMATK100")))]),
                _vm._v(" "),
                _c("th", [_vm._v("Package Code")]),
                _c("th", [
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.closeCntr,
                          expression: "!closeCntr",
                        },
                      ],
                      staticClass: "tbl_icon plus",
                      attrs: { type: "button" },
                      on: { click: _vm.addBLContainer },
                    },
                    [_vm._v(" plus ")]
                  ),
                ]),
              ]),
            ]),
            _vm._l(_vm.regParams.houseBlContainerList, function (vo, idx) {
              return _c("tbody", { key: "cntr_" + idx }, [
                _c("tr", [
                  _c("td", [_vm._v(_vm._s(idx + 1))]),
                  _c("td", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: vo.cntrNo,
                            expression: "vo.cntrNo",
                          },
                        ],
                        attrs: { id: "cntrNo_" + idx },
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                vo,
                                "cntrNo",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                            function ($event) {
                              return _vm.checkCntrNo(idx, $event)
                            },
                          ],
                        },
                      },
                      [
                        _c("option", { attrs: { value: "select" } }, [
                          _vm._v(_vm._s(_vm.$t("msg.CSBK100.394"))),
                        ]),
                        _vm._l(
                          _vm.parentInfo.parentRegParams.containerList,
                          function (cvo, i) {
                            return _c(
                              "option",
                              {
                                key: "cntr_" + i,
                                domProps: { value: cvo.cntrNo },
                              },
                              [_vm._v(_vm._s(cvo.cntrNo))]
                            )
                          }
                        ),
                      ],
                      2
                    ),
                  ]),
                  _c(
                    "td",
                    _vm._l(_vm.getSealList(vo.cntrNo), function (svo, i) {
                      return _c(
                        "div",
                        {
                          key: "hblSeal_" + idx + "_" + i,
                          staticClass: "div_seal",
                        },
                        [
                          _c("input", {
                            attrs: { type: "text", disabled: "" },
                            domProps: { value: svo.sealNo },
                          }),
                        ]
                      )
                    }),
                    0
                  ),
                  _c("td", [
                    _c("div", { staticClass: "tbl_form" }, [
                      _c(
                        "span",
                        {
                          staticClass: "dv",
                          staticStyle: { float: "left", width: "40%" },
                        },
                        [
                          _c("e-trans-string-check-input", {
                            attrs: {
                              id: "cntrHsCd_" + idx,
                              "is-upper-case": true,
                              maxlength: "6",
                              "error-message": vo.hsCdErrorMessage,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.checkHsCd($event, idx)
                              },
                            },
                            model: {
                              value: vo.hsCd,
                              callback: function ($$v) {
                                _vm.$set(vo, "hsCd", $$v)
                              },
                              expression: "vo.hsCd",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "span",
                        {
                          staticClass: "dv",
                          staticStyle: { float: "right", width: "60%" },
                        },
                        [
                          _c("div", { staticClass: "position_relative" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: vo.hsCdNm,
                                  expression: "vo.hsCdNm",
                                },
                              ],
                              attrs: { type: "text", readonly: true },
                              domProps: { value: vo.hsCdNm },
                              on: {
                                input: function ($event) {
                                  if ($event.target.composing) return
                                  _vm.$set(vo, "hsCdNm", $event.target.value)
                                },
                              },
                            }),
                          ]),
                        ]
                      ),
                    ]),
                  ]),
                  _c(
                    "td",
                    [
                      _c("e-input-number", {
                        staticClass: "col_7",
                        attrs: {
                          id: "wt_" + idx,
                          point: 3,
                          "is-comma": true,
                          maxlength: "14",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.cntrCheckValidationInfo("wt_" + idx)
                          },
                        },
                        model: {
                          value: vo.wt,
                          callback: function ($$v) {
                            _vm.$set(vo, "wt", $$v)
                          },
                          expression: "vo.wt",
                        },
                      }),
                      _vm._v(" Kgs "),
                    ],
                    1
                  ),
                  _c(
                    "td",
                    [
                      _c("e-input-number", {
                        attrs: {
                          id: "grsCbm_" + idx,
                          "is-comma": true,
                          point: 4,
                          maxlength: "8",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.cntrCheckValidationInfo("grsCbm_" + idx)
                          },
                        },
                        model: {
                          value: vo.grsCbm,
                          callback: function ($$v) {
                            _vm.$set(vo, "grsCbm", $$v)
                          },
                          expression: "vo.grsCbm",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "td",
                    [
                      _c("e-input-number", {
                        attrs: {
                          id: "cntrPkgQty_" + idx,
                          "is-comma": true,
                          maxlength: "10",
                        },
                        on: {
                          input: function ($event) {
                            return _vm.cntrCheckValidationInfo(
                              "cntrPkgQty_" + idx
                            )
                          },
                        },
                        model: {
                          value: vo.pkgQty,
                          callback: function ($$v) {
                            _vm.$set(vo, "pkgQty", $$v)
                          },
                          expression: "vo.pkgQty",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("td", [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: vo.pkgCd,
                            expression: "vo.pkgCd",
                          },
                        ],
                        attrs: { id: "cntrPkgCd_" + idx },
                        on: {
                          change: [
                            function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.$set(
                                vo,
                                "pkgCd",
                                $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              )
                            },
                            function ($event) {
                              return _vm.cntrCheckValidationInfo(
                                "cntrPkgCd_" + idx
                              )
                            },
                          ],
                        },
                      },
                      [
                        _c("option", { attrs: { value: "" } }, [
                          _vm._v(_vm._s(_vm.$t("msg.CSBL220.003"))),
                        ]),
                        _vm._l(_vm.pkgCdList, function (pvo, i) {
                          return _c(
                            "option",
                            {
                              key: "cntrPkgCd_" + idx + "_" + i,
                              domProps: { value: pvo.cd },
                            },
                            [_vm._v(_vm._s(pvo.cdNm))]
                          )
                        }),
                      ],
                      2
                    ),
                  ]),
                  _c("td", [
                    _c(
                      "button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.closeCntr,
                            expression: "!closeCntr",
                          },
                        ],
                        staticClass: "tbl_icon minus",
                        on: {
                          click: function ($event) {
                            return _vm.removeBLContainer(idx)
                          },
                        },
                      },
                      [_vm._v(" minus ")]
                    ),
                  ]),
                ]),
              ])
            }),
          ],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { staticStyle: { width: "15%" } }),
      _c("col", { staticStyle: { width: "18%" } }),
      _c("col", { staticStyle: { width: "15%" } }),
      _c("col", { staticStyle: { width: "18%" } }),
      _c("col", { staticStyle: { width: "15%" } }),
      _c("col", { staticStyle: { width: "19%" } }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { staticStyle: { width: "3%" } }),
      _c("col", { staticStyle: { width: "14%" } }),
      _c("col", { staticStyle: { width: "12%" } }),
      _c("col", { staticStyle: { width: "22%" } }),
      _c("col", { staticStyle: { width: "14%" } }),
      _c("col", { staticStyle: { width: "8%" } }),
      _c("col", { staticStyle: { width: "8%" } }),
      _c("col", { staticStyle: { width: "15%" } }),
      _c("col", { staticStyle: { width: "4%" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }